import React, { Component } from 'react';
import { Button, DatePicker, Input, Select, message } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import SelectProvince  from '../../common/SelectProvince';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from "moment";

const Option = Select.Option;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class PersonalFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchParams: { workStatus: 'WORKING' },
            isSpecialPersonnel: false,
        };
    }

    componentDidMount() {
        this.queryUserIdsByKey();
    }

    queryUserIdsByKey = () => {
        const { userId, curRole } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserIdsByKey,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { list } = res;
                const isSpecialPersonnel = (list || []).some(el => el == userId);
                this.setState({ isSpecialPersonnel },() => {
                    if (curRole === 'BO' && !isSpecialPersonnel) {
                        this.queryCurEmployeeCode(userId);
                    } else {
                        this.queryEffectiveDate();
                    }
                });
            },
        };
        $.sendRequest(options);
    }


    queryCurEmployeeCode = userId => {
        const options = {
            method: 'POST',
            url: API_URL.user.getUserInfoDetail,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { searchParams } = this.state;
                const { employee: { userId, employeeName, employeeCode } } = res;

                searchParams.teamLeaderId = userId;

                searchParams.teamLeaderName = `${employeeName}[${employeeCode}]`;

                this.setState({ searchParams }, () => {
                    this.queryEffectiveDate();
                });
            },
        };
        $.sendRequest(options);
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { searchParams } = this.state;
            const { year, month } = res;
            const maxDate = `${year}-${month < 10 ? `0${month}` : month}`;
            searchParams.begin = maxDate;
            searchParams.end = maxDate;
            this.setState({ searchParams }, () => {
                this.search();
            });
        });
    }

    search = () => {
        const { searchParams } = this.state;
        const { areaParams } = searchParams;
        const { begin, end } = searchParams;
        if (begin && end) {
            if (moment(begin).valueOf() > moment(end).valueOf()) {
                return message.warning('开始时间不能大于结束时间')
            }
            if (moment(begin).valueOf() < moment(end).add(-11, 'M').valueOf() ) {
                return message.warning('时间范围不能超过一年')
            }
        }
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        searchParams[key] = dateString;
        this.setState({ searchParams });
    }

    disabledDate = (value, key) => {
        const { searchParams: { begin, end } } = this.state;
        if (key === 'begin') {
            return end ? value.valueOf() > moment(end).valueOf() : false;
        } else {
            return begin ? value.valueOf() < moment(begin).valueOf() : false;
        }
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        const { text, value } = option;
        if (key === 'leader') {
            searchParams.leaderId = value;
            searchParams.leaderName = text;
        } else if (key === 'teamLeader') {
            searchParams.teamLeaderId = value;
            searchParams.teamLeaderName = text;
        } else if (key === 'hospital') {
            searchParams.hospitalId = value;
            searchParams.hospitalName = text;
        }
        this.setState({ searchParams });
    }

    render() {
        const { searchParams, isSpecialPersonnel } = this.state;
        const {
            begin,
            end,
            workStatus,
            areaName,
            leaderName,
            teamLeaderName,
            hasCheckedArea = [],
            hospitalName,
        } = searchParams;
        const { curRole } = sessionStorage;
        return (
            <div className="filter-bar bar2">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">时间</label>
                    <MonthPicker
                        allowClear={true}
                        placeholder="请选择"
                        format={monthFormat}
                        value={begin ? moment(begin) : null}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'begin')}
                        // disabledDate={value => this.disabledDate(value, 'begin')}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">至</label>
                    <MonthPicker
                        allowClear={true}
                        placeholder="请选择"
                        format={monthFormat}
                        value={end ? moment(end) : null}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'end')}
                        // disabledDate={value => this.disabledDate(value, 'end')}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">人员</label>
                    <Input
                        placeholder="请输入工号\姓名"
                        onChange={e => this.handleInputChange(e, 'compellationCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">当前状态</label>
                    <Select
                        style={{width:90}}
                        value={workStatus}
                        onChange={value => this.handleSelectChange(value, 'workStatus')}
                    >
                        <Option value='WORKING'>在职</Option>
                        <Option value='LEFT'>离职</Option>
                        <Option value=''>全部</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">区域/城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="form-item">
                    <label className="ui-label">主管领导</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 142 }}
                        placeholder="输入姓名/工号检索"
                        value={leaderName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleChange(option, 'leader')}
                    />
                </div>
                {
                    (curRole === 'BO' && !isSpecialPersonnel) &&
                    <div className="form-item">
                        <label className="ui-label">团队领导</label>
                        <SearchRetrieve
                            keyword='nameCode'
                            style={{ width: 142 }}
                            placeholder="输入姓名/工号检索"
                            value={teamLeaderName}
                            params={{ limit: 20 }}
                            url={API_URL.user.getAllCRCDeptUserList}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'teamLeader')}
                        />
                    </div>
                }
                <div className="form-item">
                    <label className="ui-label">医院</label>
                    <SearchRetrieve
                        keyword='hospitalName'
                        style={{ width: 200 }}
                        placeholder="输入医院名称检索"
                        value={hospitalName}
                        params={{ limit: 20 }}
                        url={API_URL.hospital.hospitalList}
                        config={{ id: 'hospitalId', name: 'hospitalName' }}
                        onChange={option => this.handleChange(option, 'hospital')}
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class TeamFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchParams: {
                begin: moment().subtract(11, 'months').format(monthFormat),
                end: moment().format(monthFormat),
            },
            isSpecialPersonnel: false,
        };
    }

    componentDidMount() {
        this.queryUserIdsByKey();
    }

    queryUserIdsByKey = () => {
        const { userId, curRole } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserIdsByKey,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { list } = res;
                const isSpecialPersonnel = (list || []).some(el => el == userId);
                this.setState({ isSpecialPersonnel },() => {
                    if (curRole === 'BO' && !isSpecialPersonnel) {
                        this.queryCurEmployeeCode(userId);
                    } else {
                        this.search();
                    }
                });
            },
        };
        $.sendRequest(options);
    }

    queryCurEmployeeCode = userId => {
        const options = {
            method: 'POST',
            url: API_URL.user.getUserInfoDetail,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { searchParams } = this.state;
                const { employee: { userId, employeeName, employeeCode } } = res;

                searchParams.teamLeaderId = userId;
                searchParams.teamLeaderName = `${employeeName}[${employeeCode}]`;

                this.setState({ searchParams }, () => {
                    this.search();
                });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { searchParams } = this.state;
        const { curRole } = sessionStorage;
        if (curRole === 'BO' && !searchParams.teamLeaderId) {
            message.warning('请选择团队领导后进行搜索');
            return;
        }
        
        this.props.search({ ...searchParams });
    }

    export = () => {
        this.props.export();
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        searchParams[key] = dateString;
        this.setState({ searchParams });
    }

    disabledDate = (value, key) => {
        const { searchParams: { begin, end } } = this.state;
        if (key === 'begin') {
            return end ? value.valueOf() > moment(end).valueOf() : false;
        } else {
            return begin ? value.valueOf() < moment(begin).valueOf() : false;
        }
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        const { text, value } = option;
        if (key === 'teamLeader') {
            searchParams.teamLeaderId = value;
            searchParams.teamLeaderName = text;
        } else if (key === 'user') {
            searchParams.userId = value;
            searchParams.userName = text;
        }
        this.setState({ searchParams });
    }

    render() {
        const { curRole } = sessionStorage;
        const { searchParams: { begin, end, userName, teamLeaderName }, isSpecialPersonnel } = this.state;
        return (
            <div className="filter-bar bar2">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">时间</label>
                    <MonthPicker
                        format={monthFormat}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'begin')}
                        allowClear={true}
                        value={begin ? moment(begin) : null}
                        disabledDate={value => this.disabledDate(value, 'begin')}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">至</label>
                    <MonthPicker
                        format={monthFormat}
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'end')}
                        allowClear={true}
                        value={end ? moment(end) : null}
                        disabledDate={value => this.disabledDate(value, 'end')}
                    />
                </div>
                {!isSpecialPersonnel &&
                <div className="form-item">
                    <label className="ui-label">团队领导</label>
                    {
                        curRole === 'BO' ?
                            <SearchRetrieve
                                keyword='nameCode'
                                style={{ width: 130 }}
                                placeholder="输入姓名/工号检索"
                                value={teamLeaderName}
                                params={{ limit: 20 }}
                                allowClear={false}
                                url={API_URL.user.getAllCRCDeptUserList}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={option => this.handleChange(option, 'teamLeader')}
                            />
                        :
                            <SearchRetrieve
                                keyword='userNameCode'
                                style={{ width: 130 }}
                                placeholder="输入姓名/工号检索"
                                value={userName}
                                params={{ limit: 20 }}
                                allowClear={false}
                                url={API_URL.user.queryActualSubordinate}
                                config={{ id: 'userId', name: 'name', code: 'employeeCode', show: 'user' }}
                                onChange={option => this.handleChange(option, 'user')}
                            />
                    }
                </div>
                }
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

export { PersonalFilter, TeamFilter };



// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/SearchFilter.js